(function () {
  'use strict';
  if (window.sahooThemeInitialized) return;
  window.sahooThemeInitialized = true;
  var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var wishlistKey = 'sahoo_wishlist_v2';
  var q = function (selector, scope) { return (scope || document).querySelector(selector); };
  var qa = function (selector, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); };
  var escapeHtml = function (value) { var node = document.createElement('div'); node.textContent = value == null ? '' : String(value); return node.innerHTML; };
  var formatMoney = function (cents) {
    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'CAD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100); }
    catch (error) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
  };
  var getDialog = function (id) { return document.getElementById(id); };
  var cartBusy = false;
  var cartRevision = 0;
  var cartError = function (message) {
    var box = q('[data-sahoo-cart-error]');
    var text = q('[data-sahoo-cart-error-text]');
    if (box) box.hidden = !message;
    if (text) text.textContent = message || '';
  };
  var defaultCartError = function () { var cart = getDialog('SAHOOCart'); return cart && cart.dataset.errorMessage || 'We couldn’t update your bag. Please try again.'; };
  var setCartBusy = function (busy) {
    cartBusy = busy;
    var items = q('[data-sahoo-cart-items]');
    if (items) { items.setAttribute('aria-busy', String(busy)); qa('button', items).forEach(function (button) { button.disabled = busy; }); }
  };
  var closeDialog = function (dialog) {
    if (!dialog) return;
    if (dialog.open && dialog.close) dialog.close();
    document.body.classList.toggle('sahoo-dialog-open', !!q('.sahoo-dialog[open]'));
    var menuDialog = getDialog('SAHOOMenu');
    document.body.classList.toggle('sahoo-menu-open', !!(menuDialog && menuDialog.open));
  };
  var openDialog = function (id) {
    qa('.sahoo-card-sheet:not([hidden])').forEach(function (sheet) { sheet.hidden = true; });
    document.body.classList.remove('sahoo-quick-open');
    var dialog = getDialog(id);
    if (!dialog) return;
    qa('.sahoo-dialog[open]').forEach(function (open) { if (open !== dialog) closeDialog(open); });
    if (!dialog.open && dialog.showModal) dialog.showModal();
    document.body.classList.add('sahoo-dialog-open');
    document.body.classList.toggle('sahoo-menu-open', id === 'SAHOOMenu');
    if (id === 'SAHOOCart') refreshCart();
    if (id === 'SAHOOWishlist') renderWishlist();
    if (id === 'SAHOOStories') dialog.dispatchEvent(new CustomEvent('sahoo:story:open'));
    var focusTarget = id === 'SAHOOSearch' ? q('input[type="search"]', dialog) : q('input, button, a', dialog);
    if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 80);
  };
  document.addEventListener('close', function (event) {
    if (!event.target.matches('.sahoo-dialog')) return;
    document.body.classList.toggle('sahoo-dialog-open', !!q('.sahoo-dialog[open]'));
    var menuDialog = getDialog('SAHOOMenu');
    document.body.classList.toggle('sahoo-menu-open', !!(menuDialog && menuDialog.open));
  }, true);
  document.addEventListener('click', function (event) { if (event.target.matches('.sahoo-dialog')) closeDialog(event.target); });
  var readWishlist = function () {
    try {
      var stored = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(stored) ? stored.filter(function (item) { return item && typeof item === 'object' && item.handle; }) : [];
    } catch (error) { return []; }
  };
  var writeWishlist = function (items) { try { localStorage.setItem(wishlistKey, JSON.stringify(items)); } catch (error) {} };
  var refreshWishlistButtons = function () {
    var handles = readWishlist().map(function (item) { return item.handle; });
    qa('[data-sahoo-wishlist]').forEach(function (button) {
      var active = handles.indexOf(button.dataset.productHandle) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };
  var renderWishlist = function () {
    var list = readWishlist();
    var container = q('[data-sahoo-saved-list]');
    var empty = q('[data-sahoo-saved-empty]');
    var accountNote = q('[data-sahoo-wishlist-account-note]');
    if (!container || !empty) return;
    container.innerHTML = '';
    empty.hidden = list.length > 0;
    if (accountNote) accountNote.hidden = document.body.dataset.sahooCustomerLoggedIn === 'true' || list.length < 1;
    list.forEach(function (item) {
      var article = document.createElement('article');
      article.className = 'sahoo-saved-item';
      var imageMarkup = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '<span></span>';
      article.innerHTML = imageMarkup + '<div class="sahoo-saved-item__content"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a><span>' + escapeHtml(item.price) + '</span></div><button type="button" data-sahoo-saved-remove="' + escapeHtml(item.handle) + '" aria-label="Remove saved product"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5.5 5.5 18.5 18.5M18.5 5.5 5.5 18.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg></button>';
      container.appendChild(article);
    });
  };
  var setButtonBusy = function (button, busy) {
    if (!button) return;
    button.classList.toggle('is-loading', busy);
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  };
  var addToCart = async function (variantId, button) {
    if (!variantId) return false;
    setButtonBusy(button, true);
    try {
      var response = await fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || defaultCartError());
      cartRevision += 1;
      cartError('');
      openDialog('SAHOOCart');
      return true;
    } catch (error) {
      if (button) {
        button.classList.add('has-error');
        var message = button.parentNode.querySelector('[data-sahoo-add-error]');
        if (!message) { message = document.createElement('p'); message.dataset.sahooAddError = ''; message.setAttribute('role', 'alert'); button.parentNode.appendChild(message); }
        message.textContent = error.message || defaultCartError();
      }
      return false;
    } finally { setButtonBusy(button, false); }
  };
  var isPriceLikeText = function (value) {
    var text = String(value || '').trim();
    if (!text) return false;
    return /(?:^|\s)(?:rs\.?|inr|cad|usd|ca\$|\$|€|£|₹)\s*[\d,.]+/i.test(text) || /^[\d,.]+\s*(?:cad|usd|inr)$/i.test(text);
  };
  var cleanCartVariantTitle = function (item) {
    var optionValues = [];
    if (Array.isArray(item.options_with_values)) {
      item.options_with_values.forEach(function (option) {
        var value = option && option.value ? String(option.value).trim() : '';
        var name = option && option.name ? String(option.name).trim() : '';
        if (!value || value === 'Default Title') return;
        if (/price|amount|cost/i.test(name) || isPriceLikeText(value)) return;
        optionValues.push(value);
      });
    }
    if (optionValues.length) return optionValues.join(' / ');
    return String(item.variant_title || '')
      .split('/')
      .map(function (part) { return part.trim(); })
      .filter(function (part) { return part && part !== 'Default Title' && !isPriceLikeText(part); })
      .join(' / ');
  };
  var cartLineMarkup = function (item) {
    var cleanVariant = cleanCartVariantTitle(item);
    var variant = cleanVariant ? '<span class="sahoo-cart-drawer__variant">' + escapeHtml(cleanVariant) + '</span>' : '';
    var publicProperties = Object.keys(item.properties || {}).filter(function (key) { return key.charAt(0) !== '_' && item.properties[key] && !/price|amount|cost/i.test(key) && !isPriceLikeText(item.properties[key]); });
    var properties = publicProperties.length ? '<span class="sahoo-cart-drawer__properties">' + publicProperties.map(function (key) { return '<small><b>' + escapeHtml(key) + ':</b> ' + escapeHtml(item.properties[key]) + '</small>'; }).join('') + '</span>' : '';
    var imageUrl = item.image ? item.image + (item.image.indexOf('?') >= 0 ? '&' : '?') + 'width=220' : '';
    var image = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" decoding="async">' : '<span class="sahoo-cart-drawer__placeholder"></span>';
    return '<article class="sahoo-cart-drawer__item"><a class="sahoo-cart-drawer__image" href="' + escapeHtml(item.url) + '">' + image + '</a><div class="sahoo-cart-drawer__item-content"><div class="sahoo-cart-drawer__item-head"><div><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant + properties + '</div><strong>' + formatMoney(item.final_line_price) + '</strong></div><div class="sahoo-cart-drawer__line-bottom"><div class="sahoo-quantity"><button type="button" data-sahoo-cart-change="-1" data-cart-key="' + escapeHtml(item.key) + '" data-cart-quantity="' + item.quantity + '" aria-label="Decrease quantity">&minus;</button><input value="' + item.quantity + '" readonly aria-label="Quantity"><button type="button" data-sahoo-cart-change="1" data-cart-key="' + escapeHtml(item.key) + '" data-cart-quantity="' + item.quantity + '" aria-label="Increase quantity">+</button></div><button class="sahoo-cart-drawer__remove" type="button" data-sahoo-cart-remove data-cart-key="' + escapeHtml(item.key) + '" aria-label="Remove item">Remove</button></div></div></article>';
  };
  var renderCart = function (cart) {
    qa('[data-sahoo-cart-count]').forEach(function (node) { node.textContent = cart.item_count; node.hidden = cart.item_count < 1; });
    qa('[data-sahoo-cart-heading-count]').forEach(function (node) { node.textContent = cart.item_count; });
    var items = q('[data-sahoo-cart-items]');
    var empty = q('[data-sahoo-cart-empty]');
    var footer = q('[data-sahoo-cart-footer]');
    if (items) items.innerHTML = cart.items.map(cartLineMarkup).join('');
    if (empty) empty.hidden = cart.item_count > 0;
    if (footer) footer.hidden = cart.item_count < 1;
    var total = q('[data-sahoo-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    qa('[data-sahoo-cart-checkout-total]').forEach(function (node) { node.textContent = formatMoney(cart.total_price); });
    var progress = q('[data-sahoo-shipping-progress]');
    if (progress) {
      var threshold = Number(progress.dataset.threshold) || 0;
      var remaining = Math.max(0, threshold - cart.total_price);
      var percent = threshold > 0 ? Math.min(100, cart.total_price / threshold * 100) : 100;
      var text = q('[data-sahoo-shipping-text]', progress);
      var bar = q('[data-sahoo-shipping-bar]', progress);
      if (text) text.textContent = remaining > 0 ? 'Spend ' + formatMoney(remaining) + ' more to unlock free shipping.' : 'You unlocked free shipping.';
      if (bar) bar.style.width = percent + '%';
    }
  };
  var refreshCart = async function () {
    var revision = ++cartRevision;
    try {
      var response = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(defaultCartError());
      var cart = await response.json();
      if (revision === cartRevision && !cartBusy) { renderCart(cart); cartError(''); }
      return cart;
    } catch (error) { if (revision === cartRevision) cartError(defaultCartError()); return null; }
  };
  var updateProductCardMediaState = function (productCard, index) {
    if (!productCard) return;
    var dots = qa('[data-sahoo-card-media-dot]', productCard);
    if (!dots.length) return;
    var nextIndex = Math.max(0, Math.min(Number(index) || 0, dots.length - 1));
    productCard.setAttribute('data-sahoo-card-media-index', String(nextIndex));
    dots.forEach(function (dot) {
      var active = Number(dot.dataset.sahooCardMediaDot) === nextIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };
  var setProductCardMedia = function (productCard, index, options) {
    if (!productCard) return;
    var dots = qa('[data-sahoo-card-media-dot]', productCard);
    if (!dots.length) return;
    var nextIndex = Math.max(0, Math.min(Number(index) || 0, dots.length - 1));
    updateProductCardMediaState(productCard, nextIndex);
    var track = q('[data-sahoo-media-track]', productCard);
    if (track && !(options && options.noScroll)) {
      track.scrollTo({ left: nextIndex * Math.max(track.clientWidth, 1), behavior: 'smooth' });
    }
  };
  var changeCart = async function (key, quantity, button) {
    if (cartBusy || !Number.isFinite(quantity)) return;
    cartRevision += 1;
    setCartBusy(true);
    cartError('');
    try {
      var response = await fetch(rootPath + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }) });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || defaultCartError());
      renderCart(result);
      var restored = qa('[data-sahoo-cart-change], [data-sahoo-cart-remove]').find(function (node) { return node.dataset.cartKey === key && node.dataset.sahooCartChange === button.dataset.sahooCartChange; });
      if (restored) { restored.disabled = false; restored.focus({ preventScroll: true }); }
      else { var close = q('[data-sahoo-dialog-close]', getDialog('SAHOOCart')); if (close) close.focus({ preventScroll: true }); }
    } catch (error) { cartError(error.message || defaultCartError()); }
    finally { setCartBusy(false); }
  };
  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-sahoo-dialog-open]');
    if (open) { event.preventDefault(); openDialog(open.dataset.sahooDialogOpen); return; }
    var close = event.target.closest('[data-sahoo-dialog-close]');
    if (close) { event.preventDefault(); closeDialog(close.closest('dialog')); return; }
    var switcher = event.target.closest('[data-sahoo-dialog-switch]');
    if (switcher) { event.preventDefault(); closeDialog(switcher.closest('dialog')); openDialog(switcher.dataset.sahooDialogSwitch); return; }
    var cardMediaDot = event.target.closest('[data-sahoo-card-media-dot]');
    if (cardMediaDot) {
      event.preventDefault();
      event.stopPropagation();
      var productCard = cardMediaDot.closest('.sahoo-product-card');
      setProductCardMedia(productCard, cardMediaDot.dataset.sahooCardMediaDot);
      return;
    }
    var cardMediaStep = event.target.closest('[data-sahoo-card-media-step]');
    if (cardMediaStep) {
      event.preventDefault();
      event.stopPropagation();
      var stepCard = cardMediaStep.closest('.sahoo-product-card');
      var stepDots = qa('[data-sahoo-card-media-dot]', stepCard);
      if (stepDots.length) {
        var currentMediaIndex = Number(stepCard.getAttribute('data-sahoo-card-media-index') || 0);
        var stepValue = Number(cardMediaStep.dataset.sahooCardMediaStep) || 1;
        setProductCardMedia(stepCard, (currentMediaIndex + stepValue + stepDots.length) % stepDots.length);
      }
      return;
    }
    var wishlist = event.target.closest('[data-sahoo-wishlist]');
    if (wishlist) {
      event.preventDefault();
      var list = readWishlist();
      var handle = wishlist.dataset.productHandle;
      var index = list.findIndex(function (item) { return item.handle === handle; });
      var savedItem = index < 0;
      if (index >= 0) list.splice(index, 1); else list.push({ handle: handle, url: wishlist.dataset.productUrl || '#', title: wishlist.dataset.productTitle || handle, price: wishlist.dataset.productPrice || '', image: wishlist.dataset.productImage || '' });
      writeWishlist(list);
      refreshWishlistButtons();
      renderWishlist();
      if (savedItem && document.body.dataset.sahooCustomerLoggedIn !== 'true') openDialog('SAHOOWishlist');
      return;
    }
    var removeSaved = event.target.closest('[data-sahoo-saved-remove]');
    if (removeSaved) { writeWishlist(readWishlist().filter(function (item) { return item.handle !== removeSaved.dataset.sahooSavedRemove; })); refreshWishlistButtons(); renderWishlist(); return; }
    var quickToggle = event.target.closest('[data-sahoo-quick-toggle]');
    if (quickToggle) {
      event.preventDefault();
      var sheet = document.getElementById(quickToggle.dataset.sahooQuickToggle);
      qa('.sahoo-card-sheet:not([hidden])').forEach(function (other) { if (other !== sheet) other.hidden = true; });
      if (sheet) {
        sheet.hidden = !sheet.hidden;
        quickToggle.setAttribute('aria-expanded', sheet.hidden ? 'false' : 'true');
        document.body.classList.toggle('sahoo-quick-open', !sheet.hidden);
        if (!sheet.hidden) { var selectedQuick = q('[data-sahoo-quick-variant].is-selected', sheet); if (selectedQuick) selectedQuick.focus(); }
      }
      return;
    }
    var quickClose = event.target.closest('[data-sahoo-quick-close]');
    if (quickClose) {
      var quickSheet = quickClose.closest('.sahoo-card-sheet');
      if (quickSheet) quickSheet.hidden = true;
      document.body.classList.remove('sahoo-quick-open');
      return;
    }
    var quickVariant = event.target.closest('[data-sahoo-quick-variant]');
    if (quickVariant) {
      var variantSheet = quickVariant.closest('[data-sahoo-quick-sheet]');
      variantSheet.dataset.selectedVariant = quickVariant.dataset.sahooQuickVariant;
      qa('[data-sahoo-quick-variant]', variantSheet).forEach(function (button) { var selected = button === quickVariant; button.classList.toggle('is-selected', selected); button.setAttribute('aria-pressed', selected ? 'true' : 'false'); });
      return;
    }
    var quickAdd = event.target.closest('[data-sahoo-quick-add]');
    if (quickAdd) {
      var addSheet = quickAdd.closest('[data-sahoo-quick-sheet]');
      addToCart(addSheet.dataset.selectedVariant, quickAdd).then(function (added) { if (added) { addSheet.hidden = true; document.body.classList.remove('sahoo-quick-open'); } });
      return;
    }
    var quickBuy = event.target.closest('[data-sahoo-quick-buy]');
    if (quickBuy) {
      var buySheet = quickBuy.closest('[data-sahoo-quick-sheet]');
      window.location.href = rootPath + 'cart/' + buySheet.dataset.selectedVariant + ':1?checkout';
      return;
    }
    var directAdd = event.target.closest('[data-sahoo-direct-add]');
    if (directAdd) { event.preventDefault(); addToCart(directAdd.dataset.sahooDirectAdd, directAdd).then(function (added) { if (added) { var sheetParent = directAdd.closest('.sahoo-card-sheet'); if (sheetParent) sheetParent.hidden = true; } }); return; }
    var cartChange = event.target.closest('[data-sahoo-cart-change]');
    if (cartChange) { var nextQuantity = Number(cartChange.dataset.cartQuantity) + Number(cartChange.dataset.sahooCartChange); changeCart(cartChange.dataset.cartKey, nextQuantity, cartChange); return; }
    var cartRemove = event.target.closest('[data-sahoo-cart-remove]');
    if (cartRemove) { changeCart(cartRemove.dataset.cartKey, 0, cartRemove); return; }
    var pageQuantity = event.target.closest('[data-sahoo-page-quantity]');
    if (pageQuantity) { var pageInput = q('input[type="number"]', pageQuantity.closest('.sahoo-quantity')); if (pageInput) pageInput.value = Math.max(0, Number(pageInput.value) + Number(pageQuantity.dataset.sahooPageQuantity)); return; }
    if (!event.target.closest('.sahoo-product-card')) {
      qa('.sahoo-card-sheet:not([hidden])').forEach(function (sheet) { sheet.hidden = true; });
      document.body.classList.remove('sahoo-quick-open');
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    qa('.sahoo-card-sheet:not([hidden])').forEach(function (sheet) { sheet.hidden = true; });
    document.body.classList.remove('sahoo-quick-open');
  });
  var swipeStart = null;
  document.addEventListener('pointerdown', function (event) {
    var media = event.target.closest('.sahoo-product-card__media');
    if (!media || event.target.closest('button')) return;
    if (q('[data-sahoo-media-track]', media)) return;
    swipeStart = { x: event.clientX, y: event.clientY, card: media.closest('.sahoo-product-card') };
  }, { passive: true });
  document.addEventListener('pointerup', function (event) {
    if (!swipeStart || !swipeStart.card) { swipeStart = null; return; }
    var dx = event.clientX - swipeStart.x;
    var dy = event.clientY - swipeStart.y;
    if (Math.abs(dx) > 34 && Math.abs(dx) > Math.abs(dy) * 1.2) {
      var dots = qa('[data-sahoo-card-media-dot]', swipeStart.card);
      var current = Number(swipeStart.card.getAttribute('data-sahoo-card-media-index') || 0);
      var next = dx < 0 ? current + 1 : current - 1;
      if (dots.length) {
        event.preventDefault();
        setProductCardMedia(swipeStart.card, (next + dots.length) % dots.length);
        var swipedCard = swipeStart.card;
        swipedCard.setAttribute('data-sahoo-swipe-block', 'true');
        window.setTimeout(function () { swipedCard.removeAttribute('data-sahoo-swipe-block'); }, 260);
      }
    }
    swipeStart = null;
  });
  document.addEventListener('click', function (event) {
    var mediaLink = event.target.closest('.sahoo-product-card__image-wrap');
    if (mediaLink && mediaLink.closest('.sahoo-product-card[data-sahoo-swipe-block]')) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
  qa('[data-sahoo-media-track]').forEach(function (track) {
    var card = track.closest('.sahoo-product-card');
    if (!card) return;
    var raf = 0;
    var down = null;
    var markSwipe = function () {
      card.setAttribute('data-sahoo-swipe-block', 'true');
      window.clearTimeout(track._sahooSwipeTimer);
      track._sahooSwipeTimer = window.setTimeout(function () { card.removeAttribute('data-sahoo-swipe-block'); }, 180);
    };
    var sync = function () {
      raf = 0;
      var width = Math.max(track.clientWidth, 1);
      updateProductCardMediaState(card, Math.round(track.scrollLeft / width));
    };
    track.addEventListener('scroll', function () {
      if (!raf) raf = window.requestAnimationFrame(sync);
    }, { passive: true });
    track.addEventListener('pointerdown', function (event) {
      down = { x: event.clientX, y: event.clientY, scrollLeft: track.scrollLeft };
    }, { passive: true });
    track.addEventListener('pointerup', function (event) {
      if (!down) return;
      var moved = Math.abs(event.clientX - down.x) > 8 || Math.abs(track.scrollLeft - down.scrollLeft) > 8;
      if (moved) markSwipe();
      down = null;
    }, { passive: true });
    track.addEventListener('click', function (event) {
      if (card.hasAttribute('data-sahoo-swipe-block')) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
    sync();
  });
  var setGenderGrid = function (grid, gender) {
    var visible = 0;
    var productLimit = Number(grid.dataset.productLimit || 50);
    qa('[data-sahoo-gender-toggle]', grid).forEach(function (button) {
      var active = button.dataset.sahooGenderToggle === gender;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    qa('[data-sahoo-gender-product]', grid).forEach(function (product) {
      var genders = (product.dataset.gender || '').split(/\s+/);
      var show = genders.indexOf(gender) !== -1 && visible < productLimit;
      product.hidden = !show;
      if (show) {
        visible += 1;
        var card = product.querySelector('.sahoo-product-card');
        if (card) card.setAttribute('data-sahoo-card-context', gender);
        qa('[data-sahoo-card-url]', product).forEach(function (link) {
          var nextUrl = gender === 'women' ? link.dataset.sahooWomenUrl : link.dataset.sahooMenUrl;
          if (nextUrl) link.setAttribute('href', nextUrl);
        });
        var wishlist = q('[data-sahoo-wishlist]', product);
        if (wishlist) {
          var wishlistImage = gender === 'women' ? wishlist.dataset.productWomenImage : wishlist.dataset.productMenImage;
          if (wishlistImage) wishlist.dataset.productImage = wishlistImage;
          var wishlistUrlLink = q('[data-sahoo-card-url]', product);
          if (wishlistUrlLink) wishlist.dataset.productUrl = wishlistUrlLink.getAttribute('href') || wishlist.dataset.productUrl;
        }
      }
    });
    var empty = q('[data-sahoo-gender-empty]', grid);
    if (empty) empty.hidden = visible > 0;
  };
  qa('[data-sahoo-gender-grid]').forEach(function (grid) { setGenderGrid(grid, 'men'); });
  document.addEventListener('click', function (event) {
    var genderButton = event.target.closest('[data-sahoo-gender-toggle]');
    if (!genderButton) return;
    var grid = genderButton.closest('[data-sahoo-gender-grid]');
    if (grid) setGenderGrid(grid, genderButton.dataset.sahooGenderToggle);
  });
  qa('[data-product-root]').forEach(function (productRoot) {
    var form = q('.sahoo-product-form', productRoot);
    var variantData = q('[data-variant-json]', form);
    if (!form || !variantData) return;
    var variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (error) {}
    var idInput = q('[data-sahoo-variant-id]', form);
    var atc = q('[data-sahoo-atc]', form);
    var buyNow = q('[data-sahoo-buy-now]', form);
    var status = q('[data-sahoo-product-status]', form);
    var groups = qa('[data-option-position]', form);
    var selectedOptions = function () { return groups.map(function (group) { var selected = q('input:checked', group); return selected ? selected.value : null; }); };
    var findVariant = function (options) { return variants.find(function (variant) { return variant.options.every(function (value, index) { return String(value) === String(options[index]); }); }); };
    var syncAvailability = function () {
      var selected = selectedOptions();
      groups.forEach(function (group, groupIndex) {
        qa('input[type="radio"]', group).forEach(function (input) {
          var trial = selected.slice(); trial[groupIndex] = input.value;
          var available = variants.some(function (variant) { return variant.available && variant.options.every(function (value, index) { return index > groupIndex || String(value) === String(trial[index]); }); });
          input.disabled = !available;
          var label = document.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-disabled', !available);
        });
      });
    };
    var updateVariant = function () {
      var variant = findVariant(selectedOptions());
      if (variant && idInput) idInput.value = variant.id;
      var available = !!(variant && variant.available);
      if (atc) { atc.disabled = !available; atc.textContent = available ? 'ADD TO BAG' : 'SOLD OUT'; }
      if (buyNow) buyNow.disabled = !available;
      if (status) status.textContent = variant ? '' : 'This option combination is unavailable.';
      var price = q('.sahoo-product-price', productRoot);
      if (price && variant) price.innerHTML = '<span' + (variant.compare_at_price > variant.price ? ' class="sahoo-price__sale"' : '') + '>' + formatMoney(variant.price) + '</span>' + (variant.compare_at_price > variant.price ? '<s class="sahoo-price__compare">' + formatMoney(variant.compare_at_price) + '</s>' : '');
      if (variant && variant.featured_media) {
        var media = q('[data-media-id="' + variant.featured_media.id + '"]', productRoot);
        var track = q('.sahoo-product-gallery__track', productRoot);
        if (media && track) {
          if (window.matchMedia('(min-width: 990px)').matches) media.scrollIntoView({ behavior: 'smooth', block: 'start' });
          else track.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
        }
      }
      if (variant && window.history && window.history.replaceState) window.history.replaceState({}, '', productRoot.dataset.productUrl + '?variant=' + variant.id);
      syncAvailability();
      return variant;
    };
    form.addEventListener('change', updateVariant);
    form.addEventListener('submit', function (event) { event.preventDefault(); var variant = updateVariant(); if (variant && variant.available) addToCart(variant.id, atc); });
    if (buyNow) buyNow.addEventListener('click', function () { var variant = updateVariant(); if (variant && variant.available) window.location.href = rootPath + 'cart/' + variant.id + ':1?checkout'; });
    syncAvailability();
  });
  qa('[data-sahoo-gallery]').forEach(function (gallery) {
    var track = q('.sahoo-product-gallery__track', gallery);
    var current = q('[data-sahoo-gallery-current]', gallery);
    var dots = qa('[data-sahoo-gallery-dot]', gallery);
    if (!track) return;
    var update = function () { var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); if (current) current.textContent = index + 1; dots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === index); }); };
    track.addEventListener('scroll', update, { passive: true });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { track.scrollTo({ left: Number(dot.dataset.sahooGalleryDot) * track.clientWidth, behavior: 'smooth' }); }); });
    update();
  });
  qa('[data-sahoo-category-stack]').forEach(function (stack) {
    var cards = qa('[data-sahoo-category-card]', stack);
    var stage = stack.closest('.sahoo-category-stage');
    var dots = stage ? qa('[data-sahoo-category-dot]', stage) : [];
    if (!cards.length) return;
    var activeIndex = 0;
    var setActive = function (index) {
      activeIndex = (Number(index) + cards.length) % cards.length;
      cards.forEach(function (card, cardIndex) {
        card.classList.toggle('is-active', cardIndex === activeIndex);
        card.classList.toggle('is-prev', cardIndex === (activeIndex - 1 + cards.length) % cards.length);
        card.classList.toggle('is-next', cardIndex === (activeIndex + 1) % cards.length);
        card.setAttribute('aria-hidden', cardIndex === activeIndex ? 'false' : 'true');
      });
      dots.forEach(function (dot) { dot.classList.toggle('is-active', Number(dot.dataset.sahooCategoryDot) === activeIndex); });
    };
    cards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        var index = Number(card.dataset.sahooCategoryCard);
        if (index !== activeIndex) {
          event.preventDefault();
          setActive(index);
        }
      });
    });
    var categorySwipe = null;
    stack.addEventListener('pointerdown', function (event) {
      categorySwipe = { x: event.clientX, y: event.clientY };
    }, { passive: true });
    stack.addEventListener('pointerup', function (event) {
      if (!categorySwipe) return;
      var dx = event.clientX - categorySwipe.x;
      var dy = event.clientY - categorySwipe.y;
      if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.15) {
        event.preventDefault();
        setActive(dx < 0 ? activeIndex + 1 : activeIndex - 1);
      }
      categorySwipe = null;
    });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { setActive(dot.dataset.sahooCategoryDot); }); });
    if (stack.dataset.autoplay === 'true' && cards.length > 1) {
      window.setInterval(function () { if (!document.hidden) setActive(activeIndex + 1); }, Math.max(3000, Number(stack.dataset.interval) || 5000));
    }
    setActive(0);
  });
  qa('.sahoo-story-dialog').forEach(function (dialog) {
    var slides = qa('[data-sahoo-story-slide]', dialog);
    var dots = qa('[data-sahoo-story-dot]', dialog);
    var activeIndex = 0;
    var duration = 5200;
    var timer = 0;
    var paused = false;
    var stop = function () {
      window.clearTimeout(timer);
      timer = 0;
      dots.forEach(function (dot) { dot.classList.remove('is-animating'); });
    };
    var schedule = function () {
      stop();
      if (paused || !dialog.open || slides.length < 2) return;
      var activeDot = dots[activeIndex];
      if (activeDot) {
        activeDot.style.setProperty('--sahoo-story-duration', duration + 'ms');
        activeDot.classList.remove('is-animating');
        void activeDot.offsetWidth;
        activeDot.classList.add('is-animating');
      }
      timer = window.setTimeout(function () { setStory(activeIndex + 1); }, duration);
    };
    var setStory = function (index) {
      if (!slides.length) return;
      activeIndex = (Number(index) + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) { slide.classList.toggle('is-active', slideIndex === activeIndex); });
      dots.forEach(function (dot) {
        var dotIndex = Number(dot.dataset.sahooStoryDot);
        dot.classList.toggle('is-active', dotIndex === activeIndex);
        dot.classList.toggle('is-complete', dotIndex < activeIndex);
        if (dotIndex !== activeIndex) dot.classList.remove('is-animating');
      });
      schedule();
    };
    dots.forEach(function (dot) { dot.addEventListener('click', function () { setStory(dot.dataset.sahooStoryDot); }); });
    var next = q('[data-sahoo-story-next]', dialog);
    var prev = q('[data-sahoo-story-prev]', dialog);
    var pause = q('[data-sahoo-story-pause]', dialog);
    if (next) next.addEventListener('click', function () { setStory(activeIndex + 1); });
    if (prev) prev.addEventListener('click', function () { setStory(activeIndex - 1); });
    if (pause) pause.addEventListener('click', function () {
      paused = !paused;
      pause.classList.toggle('is-paused', paused);
      pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
      dialog.classList.toggle('is-paused', paused);
      if (paused) stop(); else schedule();
    });
    dialog.addEventListener('click', function (event) {
      if (paused || event.target.closest('.sahoo-story-copy, .sahoo-story-close, .sahoo-story-pause, .sahoo-story-arrow, .sahoo-story-dots')) return;
      var bounds = dialog.getBoundingClientRect();
      setStory(event.clientX > bounds.width / 2 ? activeIndex + 1 : activeIndex - 1);
    });
    dialog.addEventListener('sahoo:story:open', function () {
      paused = false;
      dialog.classList.remove('is-paused');
      if (pause) {
        pause.classList.remove('is-paused');
        pause.setAttribute('aria-pressed', 'false');
      }
      setStory(0);
    });
    dialog.addEventListener('close', stop);
    document.addEventListener('visibilitychange', function () {
      if (!dialog.open) return;
      if (document.hidden) stop(); else schedule();
    });
    setStory(0);
  });
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-sahoo-tab]');
    if (!tab) return;
    var tabs = tab.closest('[data-sahoo-tabs]');
    qa('[data-sahoo-tab]', tabs).forEach(function (button) { var active = button === tab; button.classList.toggle('is-active', active); button.setAttribute('aria-selected', active ? 'true' : 'false'); });
    qa('[data-sahoo-panel]', tabs).forEach(function (panel) { var active = panel.dataset.sahooPanel === tab.dataset.sahooTab; panel.classList.toggle('is-active', active); panel.hidden = !active; });
  });
  var header = q('[data-sahoo-header]');
  var syncHeader = function () { header = q('[data-sahoo-header]'); if (header) header.classList.toggle('is-scrolled', window.scrollY > 16); };
  window.addEventListener('scroll', syncHeader, { passive: true });
  syncHeader();
  document.addEventListener('sahoo:cart:open', function () { openDialog('SAHOOCart'); });
  var initialCart = q('[data-sahoo-cart-initial]');
  if (initialCart) { try { renderCart(JSON.parse(initialCart.textContent)); } catch (error) { refreshCart(); } }
  refreshWishlistButtons();
  document.addEventListener('shopify:section:load', function () { syncHeader(); refreshWishlistButtons(); if (getDialog('SAHOOCart')) refreshCart(); });
  document.addEventListener('shopify:section:unload', function (event) {
    qa('.sahoo-dialog[open]', event.target).forEach(closeDialog);
  });

  qa('[data-sahoo-predictive-form]').forEach(function (form) {
    var input = q('input[type="search"]', form);
    var results = q('[data-sahoo-predictive-results]', form.closest('.sahoo-search-surface'));
    var status = q('[data-sahoo-predictive-status]', form);
    if (!input || !results) return;
    var initialMarkup = results.innerHTML;
    var timer = 0;
    var controller = null;
    var renderPredictive = function (data, term) {
      var resourceResults = data && data.resources && data.resources.results ? data.resources.results : {};
      var products = form.dataset.showProducts === 'true' ? (resourceResults.products || []) : [];
      var collections = form.dataset.showCollections === 'true' ? (resourceResults.collections || []) : [];
      var html = '';
      if (products.length) {
        html += '<section class="sahoo-predictive-group"><h2>Products</h2><div class="sahoo-predictive-products">';
        products.forEach(function (product) {
          var imageSource = typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image && product.featured_image.url ? product.featured_image.url : '');
          var imageUrl = imageSource ? imageSource + (imageSource.indexOf('?') >= 0 ? '&' : '?') + 'width=240' : '';
          var image = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '<span class="sahoo-predictive-placeholder"></span>';
          var productPrice = product.price_min != null ? product.price_min : product.price;
          html += '<a href="' + escapeHtml(product.url) + '">' + image + '<span><strong>' + escapeHtml(product.title) + '</strong><small>' + formatMoney(productPrice || 0) + '</small></span></a>';
        });
        html += '</div></section>';
      }
      if (collections.length) {
        html += '<section class="sahoo-predictive-group"><h2>Collections</h2><div class="sahoo-predictive-collections">';
        collections.forEach(function (collection) {
          var rawCollectionImage = typeof collection.image === 'string' ? collection.image : (collection.image && collection.image.url ? collection.image.url : '');
          var collectionImageUrl = rawCollectionImage ? rawCollectionImage + (rawCollectionImage.indexOf('?') >= 0 ? '&' : '?') + 'width=150' : '';
          var collectionImage = collectionImageUrl ? '<img src="' + escapeHtml(collectionImageUrl) + '" alt="' + escapeHtml(collection.title) + ' SAHOO collection" loading="lazy">' : '<span class="sahoo-predictive-placeholder"></span>';
          html += '<a href="' + escapeHtml(collection.url) + '">' + collectionImage + '<span>' + escapeHtml(collection.title) + '</span></a>';
        });
        html += '</div></section>';
      }
      if (!html) html = '<div class="sahoo-predictive-empty">No results for “' + escapeHtml(term) + '”</div>';
      results.innerHTML = html;
      if (status) status.textContent = products.length + collections.length + ' results available';
    };
    var requestSuggestions = function () {
      var term = input.value.trim();
      if (term.length < 2) { if (controller) controller.abort(); results.innerHTML = initialMarkup; if (status) status.textContent = ''; return; }
      if (controller) controller.abort();
      controller = new AbortController();
      results.classList.add('is-loading');
      var types = [];
      if (form.dataset.showProducts === 'true') types.push('product');
      if (form.dataset.showCollections === 'true') types.push('collection');
      var endpoint = rootPath + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=' + encodeURIComponent(types.join(',')) + '&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      fetch(endpoint, { signal: controller.signal, headers: { 'Accept': 'application/json' } }).then(function (response) { if (!response.ok) throw new Error('Predictive search failed'); return response.json(); }).then(function (data) { renderPredictive(data, term); }).catch(function (error) { if (error.name !== 'AbortError' && status) status.textContent = 'Search suggestions are unavailable.'; }).finally(function () { results.classList.remove('is-loading'); });
    };
    input.addEventListener('input', function () { window.clearTimeout(timer); timer = window.setTimeout(requestSuggestions, 180); });
    form.addEventListener('submit', function (event) { if (!input.value.trim()) event.preventDefault(); });
  });
  var optimizeImages = function () {
    qa('img').forEach(function (image) {
      if (!image.hasAttribute('decoding')) image.setAttribute('decoding', 'async');
      if (!image.hasAttribute('loading') && !image.closest('.sahoo-hero, .sahoo-header-wrap, .sahoo-product-slide:first-child')) image.setAttribute('loading', 'lazy');
      if ('fetchPriority' in image && !image.hasAttribute('fetchpriority') && !image.closest('.sahoo-hero, .sahoo-header-wrap')) {
        try { image.fetchPriority = 'low'; } catch (error) {}
      }
    });
  };
  if ('requestIdleCallback' in window) window.requestIdleCallback(optimizeImages, { timeout: 1600 });
  else window.setTimeout(optimizeImages, 700);
})();
